
import {MenuController} from '/ui/components/menu/menucontroller';
import {Tooltip} from '/ui/components/tooltip/tooltip';
import {yext} from '/ui/lib/msg';

import * as styles from '/ui/components/entitypicker/header/header.module.scss';
import GroupByIcon from '/ui/components/entitypicker/icons/groupby.svg';

/** @enum {string} */
export const GroupByType = {
  TYPE: 'type',
  FOLDER: 'folder',
  LABEL: 'label',
};

/**
 * @param {{
 *   setGroupByType: function(GroupByType): void,
 * }} props
 * @returns {React.ReactElement}
 */
export const Header = ({
  setGroupByType,
}) => {
  const getGroupByHandler = groupByType => {
    return () => {
      setGroupByType(groupByType);
    };
  };

  return (
    <div className={styles.header}>
      <span>{yext.msg('Select Entity')}</span>
      <div>
        <Tooltip tooltipText={yext.msg('Group By')} direction="top">
          <MenuController
            label={
              /** @type {!React.ReactNode} */(<span
                className={styles.dropdownIcon}
                aria-label={yext.msg('Group By')}>
                <GroupByIcon />
              </span>)
            }
            actions={[
              {name: yext.msg('Type'), callback: getGroupByHandler(GroupByType.TYPE)},
              {name: yext.msg('Folder'), callback: getGroupByHandler(GroupByType.FOLDER)},
              {name: yext.msg('Label'), callback: getGroupByHandler(GroupByType.LABEL)},
            ]}
            alignMenu="right"
          />
        </Tooltip>
      </div>
    </div>
  );
};
